import * as React from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import PrwcBasicButton from "../../../../../../../ui/widgets/custom/buttons/PrwcBasicButton";
import PrwcAccordion from "../../../../../../../ui/widgets/custom/PrwcAccordion";
import PrwcAccordionTab from "../../../../../../../ui/widgets/custom/PrwcAccordionTab";
import UserAttributes from "../UserAttributes";
import UserAuthentication from "../UserAuthentication";
import UserGroups from "../UserGroups";
import UserPersonalDetails from "../UserPersonalDetails";
import UserReportingManagers from "../UserReportingManagers";
import UserWorkflows from "../UserWorkflows";
import "./User.scss";

const User = (props: any, ref: any) => {

  const { activeSections, setActiveSections } = props;
  const { t } = useTranslation();
  // const [activeTabs, setActiveTabs] = useState([0]);
  const personalInfoSubmitButtonRef: any = useRef(null);
  const authenticationSubmitButtonRef: any = useRef(null);

  const changeActiveTabs = (activeTabs: any) => {
    setActiveSections(activeTabs);
  };

  const onSubmit = (data: any) => {
    console.log("data submitted ---");
    console.log(data);
  };

  const onError = (data: any) => {
    console.log("on error ---");
    console.log(data);
  };

  const handleOnSubmit = () => {
    // It is to submit form programmatically.
    if (personalInfoSubmitButtonRef && personalInfoSubmitButtonRef.current) {
      personalInfoSubmitButtonRef.current.click();
    }

    if (
      authenticationSubmitButtonRef &&
      authenticationSubmitButtonRef.current
    ) {
      authenticationSubmitButtonRef.current.click();
    }
  };

  const personalInfoSubmitButton = () => {
    return (
      <button
        ref={personalInfoSubmitButtonRef}
        type="submit"
        className="hidden p-col-12"
      />
    );
  };

  const authenticationSubmitButton = () => {
    return (
      <button
        ref={authenticationSubmitButtonRef}
        type="submit"
        className="hidden p-col-12"
      />
    );
  };

  const headerTemplate = (title: string) => {
    return <div className="text-sm">{title}</div>;
  };

  return (
    <div className="user">
      <div className="px-2 pt-2 overflow-y-auto content-height">
        <PrwcAccordion
          activeIndex={activeSections}
          changeActiveTabs={changeActiveTabs}
        >
          <PrwcAccordionTab
            headerTemplate={headerTemplate(t("users.label.personalDetails"))}
          >
            <UserPersonalDetails
              onError={onError}
              onSubmit={onSubmit}
              submitButton={personalInfoSubmitButton}
            ></UserPersonalDetails>
          </PrwcAccordionTab>
          <PrwcAccordionTab
            headerTemplate={headerTemplate(t("users.label.authentication"))}
          >
            <UserAuthentication
              onError={onError}
              onSubmit={onSubmit}
              submitButton={authenticationSubmitButton}
            ></UserAuthentication>
          </PrwcAccordionTab>
          <PrwcAccordionTab
            headerTemplate={headerTemplate(t("users.label.workflows"))}
          >
            <UserWorkflows></UserWorkflows>
          </PrwcAccordionTab>
          <PrwcAccordionTab
            headerTemplate={headerTemplate(t("users.label.reportingManagers"))}
          >
            <UserReportingManagers></UserReportingManagers>
          </PrwcAccordionTab>
          <PrwcAccordionTab
            headerTemplate={headerTemplate(t("users.label.attributes"))}
          >
            <UserAttributes></UserAttributes>
          </PrwcAccordionTab>
          <PrwcAccordionTab
            headerTemplate={headerTemplate(t("users.label.groups"))}
          >
            <UserGroups></UserGroups>
          </PrwcAccordionTab>
        </PrwcAccordion>
      </div>
      <div className="flex justify-end px-2 border-t">
        <PrwcBasicButton
          onClick={handleOnSubmit}
          labelKey="users.action.save"
          className="w-24 h-8 my-1 bg-blue-700 border-blue-700 p-button-sm"
        ></PrwcBasicButton>
      </div>
    </div>
  );
};

export default User;
